import React, { useState, useEffect, useCallback } from "react";
import {
  AiOutlinePlus,
  AiOutlineEdit,
  AiOutlineSearch,
  AiOutlineDelete,
  AiOutlineEye,
  AiOutlineCheckCircle,
  AiOutlineCloseCircle,
  AiOutlineFilePdf,
  AiOutlineUpload,
  AiOutlineFileExcel,
} from "react-icons/ai";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "date-fns";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Input,
  Button,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from "reactstrap";

import {
  // SuperAdmin APIs
  addOrganization,
  getOrganizations,
  getOrganizationById,
  updateOrganization,
  deleteOrganization,
  toggleOrganizationStatus,
  uploadAgreement,
  resendOrganizationAgreement,
  getLatestAgreementUrl,
  getSentAgreementUrl,
  // Admin APIs
  getAdminOrganizations,
  getAdminOrganizationById,
  updateAdminOrganization,
  toggleAdminOrganizationStatus,
  getSubAdminOrganizations,
} from "../../../components/services/api";
import axios from "axios";

import "../../../styles/dashboard/SuperAdmin/OrganizationManagement.css";
import "../../../styles/dashboard/OrgUser/CreditCheck.css";
import UploadSignedAgreementModal from "../../modal/aggrementUpload/AgreementUpload";
import { formatTableDateTime12H } from "../../../utils/dateFormatter";
import PdfViewerModal from "../../PdfViewerModal/PdfViewerModal";
import OrganizationStatusModal from "../../modal/organizationStatus/OrganizationStatusModal";
import AgreementStatusModal from "../../modal/AgreementStatusModal/AgreementStatusModal";
import Spinner from "../../common/Spinner";
import * as XLSX from "xlsx";

const API_URL = process.env.REACT_APP_API_URL;
const getToken = () => sessionStorage.getItem("token") || localStorage.getItem("token");

export default function OrganizationManagement({ role = "superadmin" }) {
    // Field-specific error messages for inline display
    const [fieldErrors, setFieldErrors] = useState({});
  // Role-based permissions for SuperAdmin/Admin/SubAdmin
  const canAdd = role === "superadmin" || role === "admin" || role === "subadmin";
  const canEdit = role === "superadmin" || role === "admin" ;
  const canDelete = role === "superadmin" ; // parity requested
  const canViewDetails = role === "superadmin" || role === "admin"; // All roles can view
  const canToggleStatus = role === "superadmin" || role === "admin" || role === "subadmin";
  const canManageAgreements = role === "superadmin" || role === "admin" || role === "subadmin";
  const canApproveAgreement = role === "superadmin" || role === "admin";
  const canExport = role === "superadmin" || role === "admin" || role === "subadmin";
  
  // Role-aware API functions
  const getRoleAwareOrganizations = () => {
    console.log('🔍 OrganizationManagement: Fetching organizations with role:', role);
    if (role === "admin") {
      console.log('📞 Using getAdminOrganizations API');
      return getAdminOrganizations("", 1, 100, "all");
    }
    if (role === "subadmin") {
      console.log('📞 Using getSubAdminOrganizations API');
      return getSubAdminOrganizations("", 1, 100, "all");
    }
    console.log('📞 Using getOrganizations API');
    return getOrganizations("", role, 1, 100, "all");
  };
  
  const getRoleAwareOrganizationById = (id) => {
    if (role === "admin") {
      return getAdminOrganizationById(id);
    }
    if (role === "subadmin") {
      return getOrganizationById(id, 'subadmin');
    }
    return getOrganizationById(id, 'superadmin');
  };
  
  const updateRoleAwareOrganization = (id, payload) => {
    if (role === "admin") {
      return updateAdminOrganization(id, payload);
    }
    if (role === "subadmin") {
      return updateOrganization(id, payload, 'subadmin');
    }
    return updateOrganization(id, payload, 'superadmin');
  };
  
  const toggleRoleAwareStatus = (id, currentStatus) => {
    if (role === "admin") {
      return toggleAdminOrganizationStatus(id);
    }
    return toggleOrganizationStatus(id, currentStatus, role);
  };
  
  /* -------------------------- STATE -------------------------- */
  const [organizations, setOrganizations] = useState([]);
  const [filteredOrgs, setFilteredOrgs] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterStatus, setFilterStatus] = useState("all");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const orgsPerPage = 10;

  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState(""); // add | edit | confirm | delete | view-agreement | view-details ← ADDED
  const [selectedOrg, setSelectedOrg] = useState(null);
  const [uploading, setUploading] = useState(false);
  // const [filterStartDate, setFilterStartDate] = useState("");
  // const [filterEndDate, setFilterEndDate] = useState("");
  const [toast, setToast] = useState({ show: false, message: "", type: "" });

  //  PDF open status
  // PDF Viewer states
  const [pdfModalOpen, setPdfModalOpen] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [PdfName, setPdfName] = useState(null);

  // organization status
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [agreementStatusModalOpen, setAgreementStatusModalOpen] =
    useState(false);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedOrganization, setSelectedOrganization] = useState(null);
  const [selectedOrgForAgreement, setSelectedOrgForAgreement] = useState(null);
  const [formData, setFormData] = useState({
    organizationName: "",
    organizationType: "",
    email: "",
    phoneNumber: "",
    gstNumber: "",
    panNumber: "",
    registrationNumber: "",
    dateOfRegistration: "",
    address: "",
    contactPersonName: "",
    contactPersonMobile: "",
    city: "",
    taluka: "",
    district: "",
    state: "",
    pinCode: "",
    numberOfLoansCustomers: "",
    assignee: "",
  });
  const [subAdmins, setSubAdmins] = useState([]);
  const [resendLoadingOrgId, setResendLoadingOrgId] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submittingAction, setSubmittingAction] = useState("");
  //         HELPERS
  //   ======================= */
  const getValue = (val) =>
    val === null || val === undefined || val === "" ? "-" : val;

  const hasSignedAgreementDocument = (org) => {
    const doc = org?.agreement?.currentDocument;
    if (!doc) return false;

    const normalizedStatus = String(doc.status || "").trim().toUpperCase();
    const validStatus = ["UPLOADED", "VALIDATED", "APPROVED"].includes(normalizedStatus);
    if (!validStatus) return false;

    const version = Number(doc.version || 0);
    const filePath = String(doc.filePath || "").toLowerCase();
    return version > 1 || filePath.includes("/signed/") || filePath.includes("\\signed\\");
  };

  const handleResendAgreement = async (org) => {
    const target = org || selectedOrganization || selectedOrg;
    if (!target?.id) {
      showToast("No organization selected", "danger");
      return;
    }
    setResendLoadingOrgId(target.id);
    const res = await resendOrganizationAgreement(target.id, role);
    setResendLoadingOrgId(null);
    if (res.success) {
      showToast("Agreement email resent", "success");
    } else {
      showToast(res.error || "Failed to resend agreement", "danger");
    }
  };
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [loading, setLoading] = useState(false);

  // NEW: For Agreement Upload
  const [uploadedFile, setUploadedFile] = useState(null);

  /* -------------------------- FETCH -------------------------- */
  const fetchOrganizations = useCallback(async () => {
    console.log('🚀 Starting fetchOrganizations with role:', role);
    setLoading(true);
    try {
      const res = await getRoleAwareOrganizations();
      console.log('📦 Organizations API response:', res);
      if (res.success) {
        // res.data may be an array directly or a wrapped response; normalize
        const orgs = Array.isArray(res.data) ? res.data : (res.data?.data || res.data || []);
        console.log('Organizations data:', orgs);
        console.log('First org agreement structure:', orgs[0]?.agreement);
        setOrganizations(orgs);
      } else {
        showToast(res.error || 'Failed to load organizations', 'danger');
      }
    } catch (err) {
      showToast('Failed to load organizations', 'danger');
    } finally {
      setLoading(false);
    }
  }, [role]);

  useEffect(() => {
    fetchOrganizations();
  }, [fetchOrganizations]);

  /* -------------------------- FETCH SUB-ADMINS -------------------------- */
  const fetchSubAdmins = useCallback(async () => {
    try {
      let endpoint;
      if (role === "superadmin") {
        endpoint = `${API_URL}/superadmin/sub-admin`;
      } else if (role === "admin") {
        endpoint = `${API_URL}/admin/sub-admins`;
      } else if (role === "subadmin") {
        // Sub-admins only need themselves for display and default selection
        const userDetails = JSON.parse(sessionStorage.getItem('userDetails') || localStorage.getItem('userDetails') || '{}');
        if (userDetails?.id) {
          setSubAdmins([{ id: userDetails.id, fullName: userDetails.fullName || userDetails.name || 'You', email: userDetails.email }]);
        }
        return;
      }
      
      const res = await axios.get(endpoint, {
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      if (res?.data?.data) {
        // Filter only active subadmins
        const activeSubAdmins = res.data.data.filter(sa => sa.isActive === true);
        setSubAdmins(activeSubAdmins);
      }
    } catch (err) {
      console.error('Failed to load sub-admins:', err);
    }
  }, [role]);

  useEffect(() => {
    fetchSubAdmins();
  }, [fetchSubAdmins]);

  /* -------------------------- SEARCH + FILTER -------------------------- */
  useEffect(() => {
    const term = searchTerm.toLowerCase();
    let filtered = Array.isArray(organizations)
      ? organizations.filter((org) => {
          const matchesSearch =
            org.organizationName?.toLowerCase().includes(term) ||
            org.registrationNumber?.toLowerCase().includes(term) ||
            (org.dateOfRegistration && org.dateOfRegistration.includes(searchTerm)) ||
            org.email?.toLowerCase().includes(term) ||
            ((org.GSTNumber || org.gstNumber) || "").toLowerCase().includes(term) ||
            ((org.panNumber || org.sansthaPanNumber) || "").toLowerCase().includes(term);

          const matchesStatus =
            filterStatus === "all" ||
            (filterStatus === "active" && org.status?.toLowerCase() === "active") ||
            (filterStatus === "inactive" && org.status?.toLowerCase() === "inactive") ||
            (filterStatus === "pending" && org.status?.toLowerCase() === "pending");

          return matchesSearch && matchesStatus;
        })
      : [];

    // Date Range Filter
    if (dateFrom || dateTo) {
      filtered = filtered.filter((org) => {
        if (!org.createdAt) return false;
        const orgDate = new Date(org.createdAt);
        const fromDate = dateFrom ? new Date(dateFrom) : null;
        const toDate = dateTo ? new Date(dateTo) : null;
        
        if (fromDate && toDate) {
          return orgDate >= fromDate && orgDate <= toDate;
        } else if (fromDate) {
          return orgDate >= fromDate;
        } else if (toDate) {
          return orgDate <= toDate;
        }
        return true;
      });
    }

    if (sortConfig.key) {
      filtered.sort((a, b) => {
        const aVal = a[sortConfig.key] ?? "";
        const bVal = b[sortConfig.key] ?? "";
        return sortConfig.direction === "asc"
          ? aVal < bVal
            ? -1
            : 1
          : aVal > bVal
          ? -1
          : 1;
      });
    }

    setFilteredOrgs(filtered);
    setCurrentPage(1);
  }, [searchTerm, filterStatus, dateFrom, dateTo, organizations, sortConfig]);

  /* -------------------------- EXPORT TO EXCEL (SuperAdmin & Admin Only) -------------------------- */
  const handleExportToExcel = () => {
    const dataToExport = currentOrgs.map((org, index) => ({
      "Sr No.": indexOfFirst + index + 1,
      "Organization Name": org.organizationName || "-",
      "Organization Type": org.organizationType || "-",
      "Email": org.email || "-",
      "Mobile Number": org.mobileNumber || "-",
      "Registration Number": org.registrationNumber || "-",
      "Registration Date": org.dateOfRegistration ? new Date(org.dateOfRegistration).toLocaleDateString() : "-",
      "GST Number": org.gstNumber || org.GSTNumber || "-",
      "PAN Number": org.panNumber || org.sansthaPanNumber || "-",
      "Address": org.address || "-",
      "City": org.city || "-",
      "District": org.district || "-",
      "State": org.state || "-",
      "Pin Code": org.pinCode || "-",
      "Contact Person": org.contactPersonName || "-",
      "Contact Email": org.contactPersonEmail || "-",
      "Contact Mobile": org.contactPersonMobile || "-",
      "Assigned To": org.assignedTo?.fullName || org.assignee?.fullName || "-",
      "Status": org.status || "-",
      "Active": org.isActive ? "Yes" : "No",
      "Agreement Status": org.agreement?.status || org.agreementStatus || "-",
      "Created Date": org.createdAt ? new Date(org.createdAt).toLocaleString() : "-",
      "Updated Date": org.updatedAt ? new Date(org.updatedAt).toLocaleString() : "-",
    }));

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    
    // Set column widths for better visibility
    const columnWidths = [
      { wch: 8 },   // Sr No.
      { wch: 25 },  // Organization Name
      { wch: 18 },  // Organization Type
      { wch: 25 },  // Email
      { wch: 15 },  // Mobile Number
      { wch: 18 },  // Registration Number
      { wch: 18 },  // Registration Date
      { wch: 18 },  // GST Number
      { wch: 15 },  // PAN Number
      { wch: 25 },  // Address
      { wch: 15 },  // City
      { wch: 15 },  // District
      { wch: 15 },  // State
      { wch: 12 },  // Pin Code
      { wch: 20 },  // Contact Person
      { wch: 25 },  // Contact Email
      { wch: 15 },  // Contact Mobile
      { wch: 20 },  // Assigned To
      { wch: 12 },  // Status
      { wch: 10 },  // Active
      { wch: 18 },  // Agreement Status
      { wch: 20 },  // Created Date
      { wch: 20 },  // Updated Date
    ];
    ws['!cols'] = columnWidths;
    
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Organizations");
    XLSX.writeFile(wb, `Organization_Management_${new Date().toISOString().split("T")[0]}.xlsx`);
    
    showToast("Data exported successfully!", "success");
  };

  /* -------------------------- TOAST -------------------------- */
  useEffect(() => {
    if (toast.show) {
      const t = setTimeout(() => setToast({ show: false }), 3000);
      return () => clearTimeout(t);
    }
  }, [toast.show]);

  const showToast = (msg, type = "success") =>
    setToast({ show: true, message: msg, type });

  /* -------------------------- SORT -------------------------- */
  const handleSort = (key) => {
    let dir = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") dir = "desc";
    setSortConfig({ key, direction: dir });
  };

  /* -------------------------- PAGINATION -------------------------- */
  const indexOfLast = currentPage * orgsPerPage;
  const indexOfFirst = indexOfLast - orgsPerPage;
  const currentOrgs = filteredOrgs.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredOrgs.length / orgsPerPage);

  /* -------------------------- MODAL -------------------------- */
  const openModal = (mode, org = null) => {
    setModalMode(mode);
    setSelectedOrg(org);
    setUploadedFile(null);

    if (mode === "add") {
      // Auto-select logged-in subadmin as assignee
      const userDetails = JSON.parse(sessionStorage.getItem('userDetails') || localStorage.getItem('userDetails') || '{}');
      const assigneeValue = (role === "subadmin" && userDetails.id) ? userDetails.id : "";
      
      setFormData({
        organizationName: "",
        organizationType: "",
        email: "",
        phoneNumber: "",
        gstNumber: "",
        panNumber: "",
        registrationNumber: "",
        dateOfRegistration: "",
        address: "",
        contactPersonName: "",
        contactPersonMobile: "",
        status: "Pending",
        assignee: assigneeValue,
      });
    } else if (mode === "edit" && org) {
      setFormData({
        ...org,
        gstNumber: org.gstNumber || org.GSTNumber || "",
      });
    }
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalMode("");
    setSelectedOrg(null);
    setUploadedFile(null);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // console.log("Name", name, "Value", value);
    setFormData((p) => ({ ...p, [name]: value }));
    
    // Clear the error for this specific field when user starts typing
    if (fieldErrors[name]) {
      setFieldErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  /* -------------------------- Aggrement Document Upload (SUB-ADMIN) -------------------------- */

  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [selectedOrgId, setSelectedOrgId] = useState(null);

  const toggleUploadModal = () => {
    setIsUploadModalOpen(!isUploadModalOpen);
  };

  const handleOpenUploadModal = (orgId) => {
    setSelectedOrgId(orgId);
    setIsUploadModalOpen(true);
  };

  /* -------------------------- FILE UPLOAD (SUB-ADMIN) -------------------------- */
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (
      file &&
      file.type === "application/pdf" &&
      file.size <= 5 * 1024 * 1024
    ) {
      setUploadedFile(file);
      showToast("PDF selected: " + file.name, "info");
    } else {
      showToast("Please upload a valid PDF under 5MB", "danger");
      e.target.value = null;
    }
  };

  const handleUploadSubmit = async () => {
    // Support both selectedOrgId (sub-admin flow) and selectedOrg (admin modal flow)
    const orgId = selectedOrgId || selectedOrg?.id;
    if (!uploadedFile || !orgId) {
      showToast('Please select a PDF and organization', 'danger');
      return;
    }

    setUploading(true);
    try {
      const res = await uploadAgreement(orgId, uploadedFile, role);
      if (res?.success) {
        showToast("Agreement uploaded successfully! Awaiting Super Admin approval.", "success");
        await fetchOrganizations(); // Refresh list to show new agreementUrl
        // close upload modal if open
        setIsUploadModalOpen(false);
        setSelectedOrgId(null);
        closeModal();
      } else {
        showToast(res?.error || "Failed to upload agreement", "danger");
      }
    } catch (err) {
      console.error(err);
      showToast(err.message || "Failed to upload agreement", "danger");
    } finally {
      setUploading(false);
      setUploadedFile(null);
    }
  };

  const openPdfModal = (org) => {
    const url = org?.agreement?.document?.presignedUrl || org?.agreement?.presignedUrl || org?.agreementUrl || org?.agreement?.document?.url;
    if (!url) {
      showToast("Agreement document not available", "warning");
      return;
    }

    setPdfUrl(url);
    setPdfName(org?.agreement?.document?.fileName || org?.agreement?.fileName || "Agreement.pdf");
    setPdfModalOpen(true);
  };

  const closePdfModal = () => {
    setPdfModalOpen(false);
    setPdfUrl(null);
  };

  // const handleUploadSubmit = async () => {
  //   if (!uploadedFile || !selectedOrg?.id) return;

  //   setUploading(true);
  //   try {
  //     await uploadAgreement(selectedOrg.id, uploadedFile);

  //     showToast(
  //       "Agreement uploaded successfully! Awaiting Super Admin approval.",
  //       "success"
  //     );

  //     await fetchOrganizations(); // Refresh list to show new agreementUrl
  //     closeModal();
  //   } catch (err) {
  //     console.error(err);
  //     showToast(err.message || "Failed to upload agreement", "danger");
  //   } finally {
  //     setUploading(false);
  //   }
  // };

  /* -------------------------- APPROVE / REJECT (SUPER ADMIN) -------------------------- */
  const handleApprove = async () => {
    if (!canApproveAgreement) {
      showToast("Only admin or superadmin can approve agreements", "danger");
      return;
    }
    try {
      const updated = { ...selectedOrg, status: "Active" };
      await updateOrganization(selectedOrg.id, updated);
      await fetchOrganizations();
      showToast("Agreement approved. Organization is now Active.", "success");
      closeModal();
    } catch {
      showToast("Failed to approve", "danger");
    }
  };

  const handleReject = async () => {
    if (!canApproveAgreement) {
      showToast("Only admin or superadmin can approve/reject agreements", "danger");
      return;
    }
    try {
      const updated = { ...selectedOrg, status: "Pending", agreementUrl: "" };
      await updateOrganization(selectedOrg.id, updated);
      await fetchOrganizations();
      showToast("Agreement rejected. Please upload again.", "warning");
      closeModal();
    } catch {
      showToast("Failed to reject", "danger");
    }
  };
  const closeStatusModal = () => {
    setStatusModalOpen(false);
    setSelectedOrganization(null);
  };

  const closeAgreementStatusModal = () => {
    setAgreementStatusModalOpen(false);
    setSelectedOrgForAgreement(null);
  };
  //  1. API Call Function (single function as requested)
  const [bankActs, setBankActs] = useState([]);
  // const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const fetchBankActs = async () => {
    try {
      setLoading(true);
      setError("");
      const API_URL =
        process.env.REACT_APP_API_URL;
      const token = sessionStorage.getItem("token") || localStorage.getItem("token");

      let bankActEndpoint;
      if (role === "admin") {
        bankActEndpoint = `${API_URL}/admin/bank-acts`;
      } else if (role === "subadmin") {
        bankActEndpoint = `${API_URL}/sub-admin/bank-acts`;
      } else {
        bankActEndpoint = `${API_URL}/bank-acts`; // superadmin
      }

      const response = await axios.get(bankActEndpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      // console.log(response, "Actual Response");
      if (response.data.success) {
        setBankActs(response.data.data); // Store in state
      } else {
        setError(response.data.message || "Something went wrong");
        showToast("getting Error in Featching Organization type", error);
      }
    } catch (err) {
      setError("Unable to fetch data");
      showToast("getting Error in Featching Organization type", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBankActs();
  }, []);
  /* -------------------------- CRUD -------------------------- */
  const handleAdd = async () => {
    if (!canAdd) {
      const errorMessage = "You don't have permission to add organizations";
      setIsSubmitting(false);
      setSubmittingAction("");
      showToast(errorMessage, "danger");
      return false;
    }
    setIsSubmitting(true);
    setSubmittingAction("Adding organization...");
    
    try {
      const result = await addOrganization(
        { ...formData, gstNumber: formData.gstNumber?.trim() || undefined, status: "Pending" },
        role
      );
      
      if (!result.success) {
        console.log("Add organization error:", result.error);
        
        // Handle validation errors with details array
        if (result.error?.details && Array.isArray(result.error.details)) {
          const newFieldErrors = {};
          result.error.details.forEach((err) => {
            if (err.field && err.message) {
              newFieldErrors[err.field] = err.message;
            }
          });
          setFieldErrors(newFieldErrors);
          setIsSubmitting(false);
          setSubmittingAction("");
          showToast("Please fix the highlighted errors.", "danger");
          return false;
        }
        
        // Handle single field error (e.g., duplicate email)
        if (result.error?.field && result.error?.message) {
          const fieldName = result.error.field;
          setFieldErrors({ [fieldName]: result.error.message });
          setIsSubmitting(false);
          setSubmittingAction("");
          showToast(result.error.message, "danger");
          return false;
        }
        
        // Handle generic error message
        if (result.error?.message) {
          const errorMsg = result.error.message;
          
          // Try to map to field if possible
          let fieldMap = {};
          if (errorMsg.includes("email")) fieldMap = { email: errorMsg };
          else if (errorMsg.includes("GST") || errorMsg.includes("gstNumber")) fieldMap = { gstNumber: errorMsg };
          else if (errorMsg.includes("PAN") || errorMsg.includes("panNumber")) fieldMap = { panNumber: errorMsg };
          else if (errorMsg.includes("Registration") || errorMsg.includes("registrationNumber")) fieldMap = { registrationNumber: errorMsg };
          
          if (Object.keys(fieldMap).length > 0) {
            setFieldErrors(fieldMap);
          }
          
          setIsSubmitting(false);
          setSubmittingAction("");
          showToast(errorMsg, "danger");
          return false;
        }
        
        // Fallback error
        setIsSubmitting(false);
        setSubmittingAction("");
        showToast("Failed to add organization", "danger");
        return false;
      }
      
      // Success
      setFieldErrors({});
      await fetchOrganizations();
      setIsSubmitting(false);
      setSubmittingAction("");
      showToast("Organization registered. Agreement sent to email.", "success");
      return true;
      
    } catch (error) {
      setIsSubmitting(false);
      setSubmittingAction("");
      console.error("Error adding organization:", error);
      showToast(error?.message || "Failed to add organization", "danger");
      return false;
    }
  };

  const handleUpdate = async () => {
    if (!canEdit) {
      const errorMessage = "You don't have permission to edit organizations";
      setIsSubmitting(false);
      setSubmittingAction("");
      showToast(errorMessage, "danger");
      return false; // Return false to indicate failure
    }
    setIsSubmitting(true);
    setSubmittingAction("Updating organization...");
    
    try {
      const result = await updateRoleAwareOrganization(selectedOrg.id, {
        ...formData,
        gstNumber: formData.gstNumber?.trim() || undefined,
      });
      if (!result.success) {
        const errorMessage = result.error?.details
          ? result.error.details.map(d => `${d.field}: ${d.message}`).join(" | ")
          : result.error || "Failed to update organization";
        setIsSubmitting(false);
        setSubmittingAction("");
        showToast(errorMessage, "danger");
        return false; // Return false to indicate failure
      }
      await fetchOrganizations();
      setIsSubmitting(false);
      setSubmittingAction("");
      showToast("Organization updated!", "success");
      return true; // Return true to indicate success
    } catch (error) {
      setIsSubmitting(false);
      setSubmittingAction("");
      console.error("Error updating organization:", error);
      showToast(error?.message || "Failed to update organization", "danger");
      return false; // Return false to indicate failure
    }
  };

  const handleSubmit = async () => {
    const errors = {};
    setFieldErrors({}); // Clear previous field errors

    // Required fields validation
    if (!formData.organizationName?.trim()) {
      errors.organizationName = "Organization Name is required";
    }
    
    if (!formData.organizationType) {
      errors.organizationType = "Organization Type is required";
    }
    
    if (!formData.email?.trim()) {
      errors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errors.email = "Invalid email format";
    }
    
    if (!formData.phoneNumber?.trim()) {
      errors.phoneNumber = "Phone Number is required";
    } else if (!/^[6-9]\d{9}$/.test(formData.phoneNumber)) {
      errors.phoneNumber = "Phone Number must be 10 digits starting with 6-9";
    }
    
    if (!formData.registrationNumber?.trim()) {
      errors.registrationNumber = "Registration Number is required";
    }
    
    if (!formData.dateOfRegistration) {
      errors.dateOfRegistration = "Date of Registration is required";
    }
    
    if (!formData.address?.trim()) {
      errors.address = "Address is required";
    }
    
    if (!formData.contactPersonName?.trim()) {
      errors.contactPersonName = "Contact Person Name is required";
    }
    
    if (!formData.contactPersonMobile?.trim()) {
      errors.contactPersonMobile = "Contact Person Mobile is required";
    } else if (!/^[6-9]\d{9}$/.test(formData.contactPersonMobile)) {
      errors.contactPersonMobile = "Contact Mobile must be 10 digits starting with 6-9";
    }

    // PAN validation
    if (!formData.panNumber?.trim()) {
      errors.panNumber = "PAN is required";
    } else if (formData.panNumber.length !== 10) {
      errors.panNumber = "PAN must be exactly 10 characters";
    } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(formData.panNumber)) {
      errors.panNumber = "Invalid PAN format (e.g., ABCDE1234F)";
    }

    // GST validation (optional; validate format only when provided)
    if (formData.gstNumber?.trim()) {
      const gst = formData.gstNumber.trim();
      if (gst.length !== 15) {
        errors.gstNumber = "GST Number must be exactly 15 characters";
      } else if (!/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/.test(gst)) {
        errors.gstNumber = "Invalid GST format (e.g., 22ABCDE1234F1Z5)";
      }
    }

    // Pin code validation (if provided)
    if (formData.pinCode && !/^\d{6}$/.test(formData.pinCode)) {
      errors.pinCode = "Pin Code must be 6 digits";
    }

    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      showToast("Please fix the highlighted errors before submitting.", "danger");
      return;
    }

    try {
      let success = false;
      if (modalMode === "add") {
        success = await handleAdd();
      } else if (modalMode === "edit") {
        success = await handleUpdate();
      }
      // Only close modal on success
      if (success) {
        closeModal();
      }
    } catch (err) {
      // Don't close modal on error - let user fix the issues
      console.error("Form submission error:", err);
      // Error handling is already done in handleAdd/handleUpdate
    }
  };

  const toggleStatus = async (selectedOrg) => {
    try {
      await toggleRoleAwareStatus(selectedOrg.id, selectedOrg.status);
      await fetchOrganizations();
      const newSt = selectedOrg.status === "Active" ? "Inactive" : "Active";
      showToast(`Organization ${newSt.toLowerCase()}d`, "success");
    } catch (err) {
      showToast(err?.message || "Failed to change status", "danger");
    }
    closeModal();
  };

  const handleDelete = async () => {
    await deleteOrganization(selectedOrg.id, role);
    await fetchOrganizations();
    showToast("Organization deleted!", "success");
    closeModal();
  };

  /* -------------------------- RENDER -------------------------- */
  return (
    <div className="om-container">
      {/* ----- Full Screen Spinner ----- */}
      {isSubmitting && (
        <Spinner 
          fullScreen 
          size="large" 
          variant="logo" 
          color="primary"
          text={submittingAction}
        />
      )}
      
      {/* ----- Toast ----- */}
      {toast.show && (
        <div className={`om-toast om-toast-${toast.type}`}>
          <span>{toast.message}</span>
          <div className="om-toast-progress" />
        </div>
      )}

      <Card className="om-card shadow-sm border-0">
        <CardBody className="p-3">
          {/* Header */}
          <div className="mb-4">
            <CardTitle tag="h3" className="om-title mb-0">
              Organization Management
            </CardTitle>
          </div>

          {/* Search Bar - Top Row */}
          <div className="om-controls mb-3">
            <div className="om-search-wrapper position-relative">
              <AiOutlineSearch className="om-search-icon" />
              <Input
                type="text"
                placeholder="Search by name, reg no, email, GST, PAN..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="om-search-input ps-5"
              />
            </div>
          </div>

          {/* Filters and Actions - Second Row */}
          <div className="om-filter-row mb-4">
            <div>
              {/* Date Range Filter */}
              <div className="om-date-filter">
                <div className="om-date-inputs">
                  <Input
                    type="date"
                    value={dateFrom}
                    onChange={(e) => setDateFrom(e.target.value)}
                    className="om-date-input"
                  />
                  <span className="om-date-separator">to</span>
                  <Input
                    type="date"
                    value={dateTo}
                    onChange={(e) => setDateTo(e.target.value)}
                    className="om-date-input"
                  />
                </div>
              </div>

              {/* Status Filter */}
              <div className="om-status-filter">
                <Input
                  type="select"
                  value={filterStatus}
                  onChange={(e) => setFilterStatus(e.target.value)}
                  className="om-status-select"
                >
                  <option value="all">All Status</option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                  <option value="pending">Pending</option>
                </Input>
              </div>
            </div>

            <div>
              {/* Export Button - SuperAdmin & Admin Only */}
              {(role === "superadmin" || role === "admin") && (
                <Button
                  color="success"
                  outline
                  className="om-btn-export d-flex align-items-center gap-2"
                  onClick={handleExportToExcel}
                  disabled={currentOrgs.length === 0}
                >
                  <AiOutlineFileExcel size={18} /> Export to Excel
                </Button>
              )}

              {/* Add Button */}
              {canAdd && (
                <Button
                  color="primary"
                  className="om-btn-add d-flex align-items-center gap-2"
                  onClick={() => openModal("add")}
                  disabled={loading}
                >
                  <AiOutlinePlus size={18} /> Add Organization
                </Button>
              )}
            </div>
          </div>

          {/* Loading / Table */}
          {loading ? (
            <div className="text-center py-4">
              <span className="spinner-border spinner-border-sm me-2" />
              Loading...
            </div>
          ) : (
            <>
              <div className="om-table-container">
                <table
                  className="om-table table-hover align-middle"
                >
                    <thead className="om-thead">
                      <tr>
                        <th className="om-th">Sr No</th>
                        <th
                          className="om-th sortable"
                          onClick={() => handleSort("organizationName")}
                        >
                          Organization Name{" "}
                          {sortConfig.key === "organizationName" &&
                            (sortConfig.direction === "asc" ? "↑" : "↓")}
                        </th>
                        <th className="om-th">Type</th>
                        <th className="om-th">Email</th>
                        <th className="om-th">Contact</th>
                        {/* <th
                          className="om-th sortable"
                          onClick={() => handleSort("registrationNumber")}
                        >
                          Reg No{" "}
                          {sortConfig.key === "registrationNumber" &&
                            (sortConfig.direction === "asc" ? "↑" : "↓")}
                        </th> */}
                        <th
                          className="om-th sortable"
                          onClick={() => handleSort("createdAt")}
                        >
                          Created Date{" "}
                          {sortConfig.key === "createdAt" &&
                            (sortConfig.direction === "asc" ? "↑" : "↓")}
                        </th>
                        <th className="om-th">Total Users</th>
                        <th className="om-th">Agent Code</th>
                        <th className="om-th">Registered By</th>
                        <th className="om-th text-center">Status</th>
                        <th className="om-th text-center">Agreement</th>
                        <th className="om-th text-center">Agreement Status</th>
                        {canViewDetails && (<th className="om-th text-center">Action</th>)}
                      </tr>
                    </thead>
                    <tbody>
                      {currentOrgs.length === 0 ? (
                        <tr>
                          <td
                            colSpan="13"
                            className="text-center py-4 text-muted"
                          >
                            No organizations found
                          </td>
                        </tr>
                      ) : (
                        currentOrgs.map((org, index) => {
                          // Debug log for each org
                          console.log(`Org ${org.organizationName}:`, {
                            agreementStatus: org?.agreement?.status,
                            currentDocStatus: org?.agreement?.currentDocument?.status,
                            currentDoc: org?.agreement?.currentDocument,
                            fullAgreement: org?.agreement
                          });
                          
                          return (
                          <tr key={org.id} className="om-tr">
                            <td className="om-td">{indexOfFirst + index + 1}</td>
                            <td className="om-td fw-semibold">
                              {org.organizationName}
                            </td>
                            <td className="om-td fw-semibold">
                              {org.organizationType || "-"}
                            </td>
                            <td className="om-td">
                              <a
                                href={`mailto:${org.email}`}
                                className="text-decoration-none text-primary"
                              >
                                {org.email || "-"}
                              </a>
                            </td>
                            <td className="om-td fw-semibold">
                              {org.phoneNumber || "-"}
                            </td>
                            {/* <td className="om-td">
                              <Badge color="secondary" className="om-reg-no">
                                {org.registrationNumber || "-"}
                              </Badge>
                            </td> */}
                            <td className="om-td">
                              {org.createdAt
                                ? new Date(org.createdAt).toLocaleString()
                                : "-"}
                            </td>
                            <td className="om-td fw-semibold">
                              {org.totalUsers || "0"}
                            </td>
                            <td className="om-td">
                              {org.assignedSubAdmin?.employeeId ||
                                (org.assignee ? subAdmins.find(sa => sa.id === org.assignee)?.employeeId : null) ||
                                "-"}
                            </td>
                            <td className="om-td">
                              {(() => {
                                // Prefer assignee full name if available
                                if (org.assignedSubAdmin?.fullName) {
                                  return org.assignedSubAdmin.fullName;
                                }
                                if (org.assignee) {
                                  const sa = subAdmins.find((s) => s.id === org.assignee);
                                  if (sa?.fullName) return sa.fullName;
                                  return org.assignee; // fallback to raw id/value
                                }
                                // Fallbacks
                                return org.registeredBy || org.createdBy || "-";
                              })()}
                            </td>
                            <td className="text-center">
                              <Badge
                                role="button"
                                className="om-cursor-pointer"
                                color={
                                  org.status === "ACTIVE"
                                    ? "success"
                                    : org.status === "PENDING"
                                    ? "warning"
                                    : org.status === "REJECTED"
                                    ? "danger"
                                    : "secondary"
                                }
                                onClick={() => {
                                  if (org.agreement?.status !== "Approved") {
                                    showToast(
                                      "Upload and approve the agreement before activating",
                                      "danger"
                                    );
                                    return;
                                  }
                                  setSelectedOrganization(org);
                                  setStatusModalOpen(true);
                                }}
                              >
                                {org.status}
                              </Badge>
                            </td>
                            {/* <td className="om-td text-center">
                              {org.agreementPath ? (
                                <Button
                                  size="sm"
                                  color="link"
                                  onClick={() =>
                                    openModal("view-agreement", org)
                                  }
                                >
                                  <AiOutlineEye
                                    size={16}
                                    title="View Agreement"
                                  />
                                </Button>
                              ) : org.status === "Pending" ? (
                                <Button
                                  size="sm"
                                  color="link"
                                  // onClick={() => openModal("upload", org)}
                                  onClick={() =>
                                    handleOpenUploadModal(
                                      "b6c8d028-5e8c-4be8-b8a2-9b5b6fcab123"
                                    )
                                  }
                                >
                                  <AiOutlineUpload
                                    size={16}
                                    title="Upload Signed Agreement"
                                  />
                                </Button>
                              ) : (
                                <span className="text-muted">—</span>
                              )}
                            </td> */}
                            <td className="text-center">
                              {/* SubAdmin should not see a view action after upload. */}
                              {role !== "subadmin" && hasSignedAgreementDocument(org) ? (
                                <Button
                                  size="sm"
                                  color="link"
                                  className="text-success p-1"
                                  onClick={async () => {
                                    try {
                                      const result = await getLatestAgreementUrl(org.id, role);
                                      if (result.success && result.data?.url) {
                                        window.open(result.data.url, '_blank');
                                      } else {
                                        showToast("Signed agreement not available", "warning");
                                      }
                                    } catch (err) {
                                      showToast("Failed to load signed agreement", "danger");
                                    }
                                  }}
                                  title="View uploaded signed agreement"
                                >
                                  <AiOutlineEye size={20} />
                                </Button>
                              ) : role === "subadmin" && hasSignedAgreementDocument(org) ? (
                                <span className="text-muted">—</span>
                              ) : org?.agreement?.status !== "Approved" ? (
                                <Button
                                  size="sm"
                                  color="link"
                                  className="text-primary p-1"
                                  onClick={() => handleOpenUploadModal(org.id)}
                                  title="Upload signed agreement from organization"
                                >
                                  <AiOutlineUpload size={20} />
                                </Button>
                              ) : (
                                <span className="text-muted">—</span>
                              )}
                            </td>
                            {/* <td className="om-td fw-semibold">
                              {org?.agreement?.status}
                            </td> */}
                            {/* <td className="text-center">
                              <Badge
                                color={
                                  org?.agreement?.status === "Approved"
                                    ? "success"
                                    : org?.agreement?.status === "Generated"
                                    ? "warning"
                                    : "danger"
                                }
                              >
                                {org?.agreement?.status}
                              </Badge>
                            </td> */}
                            <td className="text-center">
                              {org.agreement?.status ? (
                                <Badge
                                  role="button"
                                  className="om-cursor-pointer"
                                  color={
                                    org.agreement.status === "Approved"
                                      ? "success"
                                      : org.agreement.status === "Rejected"
                                      ? "danger"
                                      : "warning"
                                  }
                                  onClick={() => {
                                    if (!canApproveAgreement) {
                                      showToast("Access denied: only admin or superadmin can update agreement status", "danger");
                                      return;
                                    }
                                    setSelectedOrgForAgreement(org);
                                    setAgreementStatusModalOpen(true);
                                  }}
                                >
                                  {org.agreement.status}
                                </Badge>
                              ) : (
                                <span className="text-muted">—</span>
                              )}
                            </td>

                            {/* <td className="text-center">
                              <Badge
                                role="button"
                                className="om-cursor-pointer"
                                color={
                                  org.status === "ACTIVE"
                                    ? "success"
                                    : org.status === "PENDING"
                                    ? "warning"
                                    : org.status === "REJECTED"
                                    ? "danger"
                                    : "secondary"
                                }
                                onClick={() => {
                                  setSelectedOrganization(org);
                                  setStatusModalOpen(true);
                                }}
                              >
                                {org.status}
                              </Badge>
                            </td> */}
                            {canViewDetails && (
                            <td
                              className="om-td text-center"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <div className="d-flex gap-1 justify-content-center">
                                {/* ← ADDED: Eye Icon for Full View */}
                                <Button
                                  size="sm"
                                  color="link"
                                  className="om-action-btn text-info"
                                  onClick={async () => {
                                    try {
                                      // Fetch full organization details including agreement
                                      const res = await getOrganizationById(org.id);
                                      if (res.success) {
                                        setSelectedOrganization(res.data);
                                        setViewModalOpen(true);
                                      } else {
                                        showToast("Failed to load organization details", "danger");
                                      }
                                    } catch (err) {
                                      showToast("Error loading organization details", "danger");
                                    }
                                  }}
                                  title="View Full Details"
                                >
                                  <AiOutlineEye size={16} />
                                </Button>
                                {canEdit && (
                                  <Button
                                    size="sm"
                                    color="link"
                                    className="om-action-btn om-btn-edit"
                                    onClick={() => openModal("edit", org)}
                                    title="Edit"
                                  >
                                    <AiOutlineEdit size={16} />
                                  </Button>
                                )}
                                {canDelete && (
                                  <Button
                                    size="sm"
                                    color="link"
                                    className="om-action-btn om-btn-delete"
                                    onClick={() => openModal("delete", org)}
                                    title="Delete"
                                  >
                                    <AiOutlineDelete size={16} />
                                  </Button>
                                )}
                              </div>
                            </td>
                            )}
                          </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
              </div>

              {/* Pagination */}
              <div className="om-pagination-wrapper">
                <div className="om-pagination-info">
                  Showing {indexOfFirst + 1} to{" "}
                  {Math.min(indexOfLast, filteredOrgs.length)} of{" "}
                  {filteredOrgs.length} entries
                </div>
                {totalPages > 1 && (
                  <div className="om-pagination-buttons">
                    <Button
                      size="sm"
                      color="primary"
                      outline
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage(currentPage - 1)}
                    >
                      Previous
                    </Button>
                    {[...Array(totalPages)].map((_, i) => (
                      <Button
                        key={i}
                        size="sm"
                        color="primary"
                        outline={i + 1 !== currentPage}
                        onClick={() => setCurrentPage(i + 1)}
                      >
                        {i + 1}
                      </Button>
                    ))}
                    <Button
                      size="sm"
                      color="primary"
                      outline
                      disabled={currentPage === totalPages}
                      onClick={() => setCurrentPage(currentPage + 1)}
                    >
                      Next
                    </Button>
                  </div>
                )}
              </div>
            </>
          )}
        </CardBody>
      </Card>

      {/* ---------- MODAL ---------- */}
      {modalOpen && (
        <div className="credit-modal-overlay" >
          <div className={`credit-modal-content ${
            modalMode === "view-agreement" || modalMode === "view-details"
              ? "wide"
              : modalMode === "confirm" || modalMode === "delete"
              ? "narrow"
              : "wide"
          }`} onClick={e => e.stopPropagation()}>
            <div className="credit-modal-header">
              <h2>
                {modalMode === "add" && "Add Organization"}
                {modalMode === "edit" && "Edit Organization"}
                {modalMode === "view-agreement" && "Review Signed Agreement"}
                {modalMode === "upload" && "Upload Signed Agreement"}
                {modalMode === "confirm" && "Change Status"}
                {modalMode === "delete" && "Delete Organization"}
                {modalMode === "view-details" && "Organization Details"}
              </h2>
              <button className="credit-modal-close" onClick={closeModal}>×</button>
            </div>

            <div className="credit-modal-body">
          {/* View Details Modal with Categories */}
          {modalMode === "view-details" && selectedOrg && (
            <div>
              {/* Avatar Section */}
              <div className="om-avatar-section">
                <div
                  className="om-avatar om-avatar-primary mx-auto d-flex align-items-center justify-content-center text-white"
                >
                  {selectedOrg.organizationName?.charAt(0).toUpperCase()}
                </div>
                <div className="om-avatar-name">{selectedOrg.organizationName}</div>
                <div className="om-avatar-role">{selectedOrg.organizationType}</div>
              </div>

              {/* Organization Information */}
              <div className="om-category-section">
                <div className="om-category-title">Organization Information</div>
                <Row>
                  <Col md="6">
                    <FormGroup>
                      <Label className="om-view-label">Organization Name</Label>
                      <Input
                        type="text"
                        value={selectedOrg.organizationName || "-"}
                        disabled
                        className="om-view-value"
                      />
                    // ...existing code...
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label className="om-view-label">Total Users</Label>
                      <Input
                        type="text"
                        value={selectedOrg.totalUsers || "0"}
                        disabled
                        className="om-view-value"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label className="om-view-label">Registered By</Label>
                      <Input
                        type="text"
                        value={selectedOrg.registeredBy || selectedOrg.createdBy || "-"}
                        disabled
                        className="om-view-value"
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>

              {/* Contact Information */}
              <div className="om-category-section">
                <div className="om-category-title">Contact Information</div>
                <Row>
                  <Col md="6">
                    <FormGroup>
                      <Label className="om-view-label">Email</Label>
                      <Input
                        type="text"
                        value={selectedOrg.email || "-"}
                        disabled
                        className="om-view-value"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label className="om-view-label">Phone Number</Label>
                      <Input
                        type="text"
                        value={selectedOrg.phoneNumber || "-"}
                        disabled
                        className="om-view-value"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label className="om-view-label">Contact Person Name</Label>
                      <Input
                        type="text"
                        value={selectedOrg.contactPersonName || "-"}
                        disabled
                        className="om-view-value"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label className="om-view-label">Contact Person Mobile</Label>
                      <Input
                        type="text"
                        value={selectedOrg.contactPersonMobile || "-"}
                        disabled
                        className="om-view-value"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <FormGroup>
                      <Label className="om-view-label">Address</Label>
                      <Input
                        type="textarea"
                        value={selectedOrg.address || "-"}
                        disabled
                        className="om-view-value"
                        rows="2"
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>

              {/* Tax & Compliance Information */}
              <div className="om-category-section">
                <div className="om-category-title">Tax & Compliance Information</div>
                <Row>
                  <Col md="6">
                    <FormGroup>
                      <Label className="om-view-label">PAN Number</Label>
                      <Input
                        type="text"
                        value={selectedOrg.panNumber || selectedOrg.sansthaPanNumber || "-"}
                        disabled
                        className="om-view-value"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label className="om-view-label">GST Number</Label>
                      <Input
                        type="text"
                        value={selectedOrg.GSTNumber || selectedOrg.gstNumber || "-"}
                        disabled
                        className="om-view-value"
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>

              {/* System Information */}
              <div className="om-category-section">
                <div className="om-category-title">System Information</div>
                <Row>
                  <Col md="6">
                    <FormGroup>
                      <Label className="om-view-label">Status</Label>
                      <div>
                        <Badge
                          color={
                            selectedOrg.status === "ACTIVE" || selectedOrg.status === "Active"
                              ? "success"
                              : selectedOrg.status === "PENDING" || selectedOrg.status === "Pending"
                              ? "warning"
                              : "danger"
                          }
                          className="px-3 py-2"
                        >
                          {selectedOrg.status}
                        </Badge>
                      </div>
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label className="om-view-label">Agreement Status</Label>
                      <div>
                        {selectedOrg.agreement?.status ? (
                          <Badge
                            color={
                              selectedOrg.agreement.status === "Approved"
                                ? "success"
                                : selectedOrg.agreement.status === "Rejected"
                                ? "danger"
                                : "warning"
                            }
                            className="px-3 py-2"
                          >
                            {selectedOrg.agreement.status}
                          </Badge>
                        ) : (
                          <span className="text-muted">—</span>
                        )}
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </div>
          )}

          {modalMode === "view-agreement" ? (
            <div className="om-pdf-viewer">
              <iframe
                src={
                  selectedOrg?.agreementPath ||
                  "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf"
                }
                width="100%"
                height="600"
                className="om-iframe-borderless"
                title="Signed Agreement"
              />
            </div>
          ) : modalMode === "upload" ? (
            <div className="text-center py-4">
              <Input
                type="file"
                accept=".pdf"
                onChange={handleFileUpload}
                className="mb-3"
              />
              <small className="text-muted d-block">
                Only PDF files allowed (max 5MB)
              </small>

              {uploadedFile && (
                <div className="mt-3 p-3 border rounded bg-light">
                  <AiOutlineFilePdf className="text-danger me-2" size={20} />
                  <strong>{uploadedFile.name}</strong>
                  <br />
                  <small>
                    {(uploadedFile.size / 1024 / 1024).toFixed(2)} MB
                  </small>
                </div>
              )}
            </div>
          ) : modalMode === "confirm" ? (
            <p className="mb-0">
              Are you sure you want to{" "}
              <strong>
                {selectedOrg?.status === "Active" ? "deactivate" : "activate"}
              </strong>{" "}
              <span className="text-primary fw-bold">
                {selectedOrg?.organizationName}
              </span>
              ?
            </p>
          ) : modalMode === "delete" ? (
            <p className="mb-0">
              Are you sure you want to{" "}
              <strong className="text-danger">permanently delete</strong>{" "}
              <span className="text-primary fw-bold">
                {selectedOrg?.organizationName}
              </span>
              ?
              <br />
              <small className="text-muted">
                This action cannot be undone.
              </small>
            </p>
          ) : modalMode === "view-details" ? null : (
            /* ---------- FORM ---------- */
            <Row>
              {/* Organization Information */}
              <Col md="12">
                <h6 className="om-category-title">Organization Information</h6>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label className="om-form-label">
                    Organization Name <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="text"
                    name="organizationName"
                    placeholder="Organization Name *"
                    value={formData.organizationName}
                    onChange={handleInputChange}
                    className="mb-3"
                    invalid={!!fieldErrors.organizationName}
                  />
                  {fieldErrors.organizationName && (
                    <div className="text-danger small">{fieldErrors.organizationName}</div>
                  )}
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label className="om-form-label">Organization Type</Label>
                  <Input
                    type="select"
                    name="organizationType"
                    value={formData.organizationType}
                    onChange={handleInputChange}
                    invalid={!!fieldErrors.organizationType}
                  >
                    <option value="">Select Organization Type</option>
                    {bankActs.map((act) => (
                      <option key={act.title} value={act.title}>
                        {act.title}
                      </option>
                    ))}
                  </Input>
                  {fieldErrors.organizationType && (
                    <div className="text-danger small">{fieldErrors.organizationType}</div>
                  )}
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label className="om-form-label">
                    Registration Number <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="text"
                    name="registrationNumber"
                    placeholder="Registration Number *"
                    value={formData.registrationNumber}
                    onChange={handleInputChange}
                    className="mb-3"
                    invalid={!!fieldErrors.registrationNumber}
                  />
                  {fieldErrors.registrationNumber && (
                    <div className="text-danger small">{fieldErrors.registrationNumber}</div>
                  )}
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label className="om-form-label">Date of Registration</Label>
                  <Input
                    type="date"
                    name="dateOfRegistration"
                    value={formData.dateOfRegistration}
                    onChange={handleInputChange}
                    className="mb-3"
                    invalid={!!fieldErrors.dateOfRegistration}
                  />
                  {fieldErrors.dateOfRegistration && (
                    <div className="text-danger small">{fieldErrors.dateOfRegistration}</div>
                  )}
                </FormGroup>
              </Col>

              {/* Contact & Location Information */}
              <Col md="12">
                <h6 className="om-category-title mt-3">Contact & Location Information</h6>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label className="om-form-label">
                    Email <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="email"
                    name="email"
                    placeholder="Email *"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="mb-3"
                    invalid={!!fieldErrors.email}
                  />
                  {fieldErrors.email && (
                    <div className="text-danger small">{fieldErrors.email}</div>
                  )}
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label className="om-form-label">Phone Number</Label>
                  <Input
                    type="text"
                    name="phoneNumber"
                    placeholder="Phone Number"
                    value={formData.phoneNumber}
                    onChange={handleInputChange}
                    className="mb-3"
                    invalid={!!fieldErrors.phoneNumber}
                  />
                  {fieldErrors.phoneNumber && (
                    <div className="text-danger small">{fieldErrors.phoneNumber}</div>
                  )}
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label className="om-form-label">Contact Person</Label>
                  <Input
                    type="text"
                    name="contactPersonName"
                    placeholder="Contact Person"
                    value={formData.contactPersonName}
                    onChange={handleInputChange}
                    className="mb-3"
                    invalid={!!fieldErrors.contactPersonName}
                  />
                  {fieldErrors.contactPersonName && (
                    <div className="text-danger small">{fieldErrors.contactPersonName}</div>
                  )}
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label className="om-form-label">Contact Mobile</Label>
                  <Input
                    type="text"
                    name="contactPersonMobile"
                    placeholder="Contact Mobile"
                    value={formData.contactPersonMobile}
                    onChange={handleInputChange}
                    className="mb-3"
                    invalid={!!fieldErrors.contactPersonMobile}
                  />
                  {fieldErrors.contactPersonMobile && (
                    <div className="text-danger small">{fieldErrors.contactPersonMobile}</div>
                  )}
                </FormGroup>
              </Col>
              <Col md="12">
                <FormGroup>
                  <Label className="om-form-label">Address</Label>
                  <Input
                    type="textarea"
                    name="address"
                    placeholder="Address"
                    value={formData.address}
                    onChange={handleInputChange}
                    rows={2}
                    className="mb-3"
                    invalid={!!fieldErrors.address}
                  />
                  {fieldErrors.address && (
                    <div className="text-danger small">{fieldErrors.address}</div>
                  )}
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label className="om-form-label">City</Label>
                  <Input
                    type="text"
                    name="city"
                    placeholder="City"
                    value={formData.city}
                    onChange={handleInputChange}
                    className="mb-3"
                  />
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label className="om-form-label">Taluka</Label>
                  <Input
                    type="text"
                    name="taluka"
                    placeholder="Taluka"
                    value={formData.taluka}
                    onChange={handleInputChange}
                    className="mb-3"
                  />
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label className="om-form-label">District</Label>
                  <Input
                    type="text"
                    name="district"
                    placeholder="District"
                    value={formData.district}
                    onChange={handleInputChange}
                    className="mb-3"
                  />
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label className="om-form-label">State</Label>
                  <Input
                    type="text"
                    name="state"
                    placeholder="State"
                    value={formData.state}
                    onChange={handleInputChange}
                    className="mb-3"
                  />
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label className="om-form-label">Pin Code</Label>
                  <Input
                    type="text"
                    name="pinCode"
                    placeholder="Pin Code"
                    value={formData.pinCode}
                    onChange={handleInputChange}
                    className="mb-3"
                    maxLength="6"
                    invalid={!!fieldErrors.pinCode}
                  />
                  {fieldErrors.pinCode && (
                    <div className="text-danger small">{fieldErrors.pinCode}</div>
                  )}
                </FormGroup>
              </Col>

              {/* Tax & Compliance Information */}
              <Col md="12">
                <h6 className="om-category-title mt-3">Tax & Compliance Information</h6>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label className="om-form-label">
                    PAN <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="text"
                    name="panNumber"
                    placeholder="PAN (e.g., ABCDE1234F) *"
                    value={formData.panNumber}
                    onChange={handleInputChange}
                    className="mb-3"
                    maxLength={10}
                    invalid={!!fieldErrors.panNumber}
                  />
                  {fieldErrors.panNumber && (
                    <div className="text-danger small">{fieldErrors.panNumber}</div>
                  )}
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label className="om-form-label">GST Number</Label>
                  <Input
                    type="text"
                    name="gstNumber"
                    placeholder="GST Number (Optional)"
                    value={formData.gstNumber}
                    onChange={handleInputChange}
                    className="mb-3"
                    invalid={!!fieldErrors.gstNumber}
                  />
                  {fieldErrors.gstNumber && (
                    <div className="text-danger small">{fieldErrors.gstNumber}</div>
                  )}
                </FormGroup>
              </Col>

              {/* Additional Information */}
              <Col md="12">
                <h6 className="om-category-title mt-3">Additional Information</h6>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label className="om-form-label">Number of Loans Customers</Label>
                  <Input
                    type="text"
                    name="numberOfLoansCustomers"
                    placeholder="e.g., 400-500"
                    value={formData.numberOfLoansCustomers}
                    onChange={handleInputChange}
                    className="mb-3"
                  />
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label className="om-form-label">Assignee</Label>
                  <Input
                    type="select"
                    name="assignee"
                    value={formData.assignee}
                    onChange={handleInputChange}
                    disabled={role === "subadmin" && modalMode === "add"}
                  >
                    <option value="">Select Sub-Admin</option>
                    {subAdmins.map((subAdmin) => (
                      <option key={subAdmin.id} value={subAdmin.id}>
                        {subAdmin.employeeId ? `[${subAdmin.employeeId}] ` : ""}{subAdmin.fullName} ({subAdmin.email})
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
          )}
        </div>

        <div className="credit-modal-footer">
          {modalMode === "view-details" ? (
            <Button color="secondary" onClick={closeModal}>
              Close
            </Button>
          ) : modalMode === "view-agreement" &&
            selectedOrg?.status === "Pending" &&
            selectedOrg?.agreementPath && canApproveAgreement ? (
            <>
              <Button color="success" onClick={handleApprove}>
                <AiOutlineCheckCircle className="me-1" /> Approve
              </Button>
              <Button color="danger" onClick={handleReject}>
                <AiOutlineCloseCircle className="me-1" /> Reject
              </Button>
              <Button color="secondary" onClick={closeModal}>
                Close
              </Button>
            </>
          ) : modalMode === "view-agreement" ? (
            <Button color="secondary" onClick={closeModal}>
              Close
            </Button>
          ) : modalMode === "upload" ? (
            <>
              <Button
                color="info"
                disabled={!uploadedFile || uploading}
              >
                {uploading ? (
                  <>Uploading...</>
                ) : (
                  <>
                    <AiOutlineUpload className="me-1" /> Upload & Submit
                  </>
                )}
              </Button>
              <Button
                color="secondary"
                onClick={closeModal}
                disabled={uploading}
              >
                Cancel
              </Button>
            </>
          ) : modalMode === "add" || modalMode === "edit" ? (
            <>
              <Button
                color="primary"
                onClick={handleSubmit}
                disabled={
                  loading ||
                  isSubmitting ||
                  !formData.organizationName ||
                  !formData.email
                }
              >
                {isSubmitting ? (
                  <>
                    <span style={{ marginRight: '0.5rem' }}>
                      {modalMode === "edit" ? "Updating..." : "Adding..."}
                    </span>
                  </>
                ) : (
                  modalMode === "edit" ? "Update Organization" : "Add Organization"
                )}
              </Button>
              <Button color="secondary" onClick={closeModal} disabled={loading || isSubmitting}>
                Cancel
              </Button>
            </>
          ) : modalMode === "delete" ? (
            <>
              <Button color="danger" onClick={handleDelete}>
                Delete
              </Button>
              <Button color="secondary" onClick={closeModal}>
                Cancel
              </Button>
            </>
          ) : modalMode === "confirm" ? (
            <>
              <Button
                color="primary"
                onClick={() => toggleStatus(selectedOrg)}
              >
                Yes, Change
              </Button>
              <Button color="secondary" onClick={closeModal}>
                Cancel
              </Button>
            </>
          ) : null}
        </div>
      </div>
    </div>
      )}
      {/* =======================
            VIEW ORGANIZATION MODAL
      ======================= */}
      {viewModalOpen && (
        <div className="credit-modal-overlay" onClick={() => setViewModalOpen(false)}>
          <div className="credit-modal-content wide" onClick={e => e.stopPropagation()}>
            <div className="credit-modal-header">
              <h2>Organization Details</h2>
              <button className="credit-modal-close" onClick={() => setViewModalOpen(false)}>×</button>
            </div>
            <div className="credit-modal-body">
          {selectedOrganization && (
            <>
              <h6 className="mb-3 text-muted">Basic Information</h6>
              <Row className="g-3 mb-4">
                <Col md={4}>
                  <FormGroup>
                    <Label>Organization Name</Label>
                    <Input
                      value={getValue(selectedOrganization.organizationName)}
                      disabled
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Organization Type</Label>
                    <Input
                      value={getValue(selectedOrganization.organizationType)}
                      disabled
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Status</Label>
                    <Input
                      value={getValue(selectedOrganization.status)}
                      disabled
                    />
                  </FormGroup>
                </Col>
              </Row>

              <h6 className="mb-3 text-muted">Contact & Location Information</h6>
              <Row className="g-3 mb-4">
                <Col md={4}>
                  <FormGroup>
                    <Label>Email</Label>
                    <Input
                      value={getValue(selectedOrganization.email)}
                      disabled
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Mobile Number</Label>
                    <Input
                      value={getValue(selectedOrganization.phoneNumber)}
                      disabled
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Contact Person</Label>
                    <Input
                      value={getValue(selectedOrganization.contactPersonMobile)}
                      disabled
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>City</Label>
                    <Input
                      value={getValue(selectedOrganization.city)}
                      disabled
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Taluka</Label>
                    <Input
                      value={getValue(selectedOrganization.taluka)}
                      disabled
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>District</Label>
                    <Input
                      value={getValue(selectedOrganization.district)}
                      disabled
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>State</Label>
                    <Input
                      value={getValue(selectedOrganization.state)}
                      disabled
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Pin Code</Label>
                    <Input
                      value={getValue(selectedOrganization.pinCode)}
                      disabled
                    />
                  </FormGroup>
                </Col>
              </Row>

              <h6 className="mb-3 text-muted">Legal Information</h6>
              <Row className="g-3 mb-4">
                <Col md={4}>
                  <FormGroup>
                    <Label>Number of Loans Customers</Label>
                    <Input
                      value={getValue(selectedOrganization.numberOfLoansCustomers)}
                      disabled
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Assignee</Label>
                    <Input
                      value={
                        selectedOrganization.assignee
                          ? subAdmins.find(sa => sa.id === selectedOrganization.assignee)?.fullName || getValue(selectedOrganization.assignee)
                          : "-"
                      }
                      disabled
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label className="fw-bold">Agreements</Label>
                    <div className="d-flex flex-column gap-3 mt-2">
                      {/* Sent Agreement (generated and sent via email) */}
                      {selectedOrganization?.agreement?.id && (
                        <div className="border rounded p-3 bg-white shadow-sm">
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="flex-grow-1">
                              <div className="d-flex align-items-center gap-2">
                                <AiOutlineFilePdf size={24} className="text-primary" />
                                <strong className="text-primary">Sent Agreement</strong>
                                <Badge color="info" className="ms-2">Generated</Badge>
                              </div>
                              <div className="text-muted small mt-1">Generated and sent to organization via email</div>
                            </div>
                            <Button
                              color="primary"
                              size="sm"
                              className="d-flex align-items-center"
                              onClick={async () => {
                                try {
                                  const result = await getSentAgreementUrl(selectedOrganization.id, role);
                                  if (result.success && result.data?.url) {
                                    window.open(result.data.url, '_blank');
                                  } else {
                                    showToast("Sent agreement not available", "warning");
                                  }
                                } catch (err) {
                                  console.error("Error loading sent agreement:", err);
                                  showToast("Failed to load sent agreement", "danger");
                                }
                              }}
                            >
                              <AiOutlineEye size={16} className="me-1" /> View
                            </Button>
                          </div>
                        </div>
                      )}

                      {/* Signed Agreement (uploaded and validated, only if approved) */}
                      {selectedOrganization?.agreement?.status === "Approved" &&
                        selectedOrganization?.agreement?.currentDocument?.status === "Validated" ? (
                        <div className="border rounded p-3 bg-light shadow-sm">
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="flex-grow-1">
                              <div className="d-flex align-items-center gap-2">
                                <AiOutlineFilePdf size={24} className="text-success" />
                                <strong className="text-success">Signed Agreement</strong>
                                <Badge color="success" className="ms-2">Validated</Badge>
                              </div>
                              <div className="text-muted small mt-1">
                                Version {selectedOrganization.agreement.currentDocument.version} | Uploaded by organization
                              </div>
                            </div>
                            <Button
                              color="success"
                              size="sm"
                              className="d-flex align-items-center"
                              onClick={async () => {
                                try {
                                  const result = await getLatestAgreementUrl(selectedOrganization.id, role);
                                  if (result.success && result.data?.url) {
                                    window.open(result.data.url, '_blank');
                                  } else {
                                    showToast("Signed agreement not available", "warning");
                                  }
                                } catch (err) {
                                  showToast("Failed to load signed agreement", "danger");
                                }
                              }}
                            >
                              <AiOutlineEye size={16} className="me-1" /> View Signed PDF
                            </Button>
                          </div>
                        </div>
                      ) : selectedOrganization?.agreement?.status === "Approved" ? (
                        <div className="border rounded p-3 bg-light shadow-sm">
                          <div className="d-flex align-items-center gap-2">
                            <AiOutlineFilePdf size={24} className="text-muted" />
                            <strong className="text-muted">Signed Agreement</strong>
                            <Badge color="secondary" className="ms-2">Approved</Badge>
                            <span className="ms-2 text-muted">—</span>
                          </div>
                          <div className="text-muted small mt-1">No validated signed agreement uploaded</div>
                        </div>
                      ) : (
                        <div className="border rounded p-3 bg-light shadow-sm">
                          <div className="d-flex align-items-center gap-2">
                            <AiOutlineFilePdf size={24} className="text-muted" />
                            <strong className="text-muted">Signed Agreement</strong>
                            <Badge color="secondary" className="ms-2">Not Approved</Badge>
                            <span className="ms-2 text-muted">—</span>
                          </div>
                          <div className="text-muted small mt-1">Agreement not approved or not uploaded</div>
                        </div>
                      )}

                      {/* No agreements available */}
                      {!selectedOrganization?.agreement?.status && 
                       !selectedOrganization?.agreement?.currentDocument && (
                        <div className="text-muted text-center p-3">
                          <AiOutlineFilePdf size={32} className="mb-2 opacity-50" />
                          <div>No agreements available yet</div>
                        </div>
                      )}

                      {/* Action Buttons */}
                      <div className="d-flex gap-2 mt-2">
                        {/* Show upload button only if signed agreement NOT uploaded */}
                        {!(selectedOrganization?.agreement?.currentDocument?.status === "Validated" ||
                          selectedOrganization?.agreement?.currentDocument?.status === "Uploaded") && (
                          <Button 
                            color="primary" 
                            size="sm" 
                            onClick={() => {
                              setSelectedOrgId(selectedOrganization.id);
                              setIsUploadModalOpen(true);
                            }}
                          >
                            <AiOutlineUpload size={16} className="me-1" />
                            Upload Signed Agreement
                          </Button>
                        )}
                        <Button 
                          color="secondary" 
                          size="sm" 
                          disabled={
                            resendLoadingOrgId === selectedOrganization?.id ||
                            (!selectedOrganization?.agreement?.status &&
                              !selectedOrganization?.agreement?.currentDocument)
                          }
                          onClick={() => handleResendAgreement(selectedOrganization)}
                        >
                          {resendLoadingOrgId === selectedOrganization?.id ? "Sending..." : "📧 Resend Agreement Email"}
                        </Button>
                      </div>
                    </div>
                  </FormGroup>
                </Col>
              </Row>

              <h6 className="mb-3 text-muted">System Information</h6>
              <Row className="g-3">
                <Col md={4}>
                  <FormGroup>
                    <Label>Active Status</Label>
                    <Input
                      value={
                        selectedOrganization.isActive ? "Active" : "Inactive"
                      }
                      disabled
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Created At</Label>
                    <Input
                      value={formatTableDateTime12H(
                        selectedOrganization.createdAt
                      )}
                      disabled
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Updated At</Label>
                    <Input
                      value={formatTableDateTime12H(
                        selectedOrganization.updatedAt
                      )}
                      disabled
                    />
                  </FormGroup>
                </Col>
              </Row>
            </>
          )}
            </div>
            <div className="credit-modal-footer">
              <button className="btn btn-secondary" onClick={() => setViewModalOpen(false)}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {/* ============================
          Upload Modal
      ============================ */}
      {isUploadModalOpen && (
        <UploadSignedAgreementModal
          isOpen={isUploadModalOpen}
          toggle={toggleUploadModal}
          organizationId={selectedOrgId}
          onSuccess={async () => {
            // Refresh the organization details after upload
            if (selectedOrganization?.id) {
              try {
                const res = await getOrganizationById(selectedOrganization.id);
                if (res.success) {
                  setSelectedOrganization(res.data);
                }
              } catch (err) {
                console.error("Failed to refresh organization details", err);
              }
            }
            // Also refresh the organizations list
            fetchOrganizations();
          }}
        />
      )}

      {/* PDF View modal */}
      <PdfViewerModal
        isOpen={pdfModalOpen}
        toggle={closePdfModal}
        fileUrl={pdfUrl}
        title={PdfName}
      />
      {/* Organization Status modal */}
      <OrganizationStatusModal
        isOpen={statusModalOpen}
        toggle={closeStatusModal}
        organization={selectedOrganization}
        onSuccess={fetchOrganizations}
      />
      {/* Organization Aggrement Status modal */}
      <AgreementStatusModal
        isOpen={agreementStatusModalOpen}
        toggle={closeAgreementStatusModal}
        organization={selectedOrgForAgreement}
        onSuccess={fetchOrganizations}
        role={role}
      />
    </div>
  );
}

